import React from 'react';
import ProviderForm from './ProviderForm';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import { Provider } from '../../../app/models/Provider';
import { ProviderType } from '../../../app/models/ProviderType';
import { Society } from '../../../app/models/Society';
import { Activity } from '../../../app/models/Activity';
import { User } from '../../../app/models/User';

interface Props {
    fetching?: boolean;
    fetchingGetSocieties?: boolean;
    fetchingGetUser?: boolean;
    action: () => void;
    cancel: () => void;
    provider: Provider;
    setProvider: (provider: Provider) => void;
    providerTypes: ProviderType[];
    societies: Society[];
    users: User[];
    errorFields?: any;
}

const ProviderFormContainer = ({
    fetching,
    fetchingGetSocieties,
    fetchingGetUser,
    action,
    cancel,
    provider,
    setProvider,
    providerTypes,
    societies,
    users,
    errorFields = null
}: Props) => {
    return (
        <>
            <div className="row">
                <div className="col-12">
                    <ProviderForm
                        Provider={provider}
                        providerTypes={providerTypes}
                        societies={societies}
                        users={users}
                        setProvider={setProvider}
                        errorFields={errorFields}
                        fetchingGetSocieties={fetchingGetSocieties}
                        fetchingGetUser={fetchingGetUser}
                    />
                </div>
            </div>
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={cancel} locked={fetching} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={action} locked={fetching} />
                </div>
            </div>
        </>
    );
};

export default ProviderFormContainer;
